<main>
<div class="container-box product-configurator" *ngIf="productDetail !== null" aria-labelledby="productNameSection">
  <h1 id="productNameSection">{{productDetail.displayName}}</h1>
  <!-- Error Block -->
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf='setError'>
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Please note</h2>
        <p>{{ErrorMessage}}</p>
      </div>
    </div>
  </div>
  <!-- Error Block End -->
  <!-- info Block -->
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf='setInfo'>
      <div class="alert-info" aria-label="Info">
        <i class="icon-flat-info"></i>
      </div>
      <div>
        <h2>{{infoHeader}}</h2>
        <p>{{infoMessage}}</p>
      </div>
    </div>
  </div>
  <!-- info Block End -->
  <h2 *ngIf = "this.totPricingObj.singleQuantityCheck > 1">Step 1: Enter number of licenses</h2>
   <h2 *ngIf = "this.totPricingObj.singleQuantityCheck ==  1">Step 1: Number of licenses </h2>
<form *ngIf='serviceconfigurationform' [formGroup]="serviceconfigurationform" autocomplete="off">
    <div class='lisencecontainer'  >
      
	  <!--  -->
      <div class='row' >
        <div class="qty-block"  *ngIf = "this.totPricingObj.singleQuantityCheck > 1">
          <div class='col-md-5'>
            <div class="col-sm-12 col-md-12">
              <label for="enter-quantity" class="label-block" [ngClass]="{'error-field': formErrors.qty}">Number of licenses</label>
            </div>
            <div class="col-sm-6 col-md-5">
              <input id="enter-quantity" type="text" class="form-control mar-top5" [attr.aria-describedby]="formErrors.qty ? 'qtyErrBlock' : null"
                [class.text-error]="formErrors.qty" formControlName="qty">
            </div>
            <div class="col-sm-6 col-md-4 pad-left-0">
              <button type="button" class="btn btn-secondary btn-update btn-sm" [disabled]="!serviceconfigurationform.valid" (click)='updateQty()'
                aria-label="Update the number of licenses.">Update</button>
            </div>
            <div *ngIf="formErrors.qty" id="qtyErrBlock" aria-live="polite" aria-atomic="true" class="text-danger col-sm-12 col-md-10 qty-error">
              {{ formErrors.qty }}
            </div>
          </div>
        </div>
 		<span class="col-sm-12 col-md-10" *ngIf = "this.totPricingObj.singleQuantityCheck == 1"><p class="last-text">This license allows an unlimited number of users.</p></span>
       </div>
      <div class='row'>
        <div class="col-sm-12 col-md-10 discount-copy" >
          <p class="last-text" *ngIf = "this.totPricingObj.singleQuantityCheck > 1" >You might qualify for contractual pricing, a volume discount, or both.<br/>These will be applied to your total
            charges after you select your wireless number during checkout.</p>
        </div>
		<div class="col-sm-12 col-md-10 discount-copy" *ngIf = "this.totPricingObj.singleQuantityCheck == 1">
          <p class="last-text">If you qualify for discounts, your total will be updated during checkout.</p>
        </div>
      </div>
    </div>

    <h2>Step 2: Select a product package</h2>
	
    <div *ngFor="let sku of productDetail.skus; let i = index" class='singeline' [ngClass]="{'selected-row' : sku.selected}">
      <div class='row'>
        <div class='col-md-7'>
          <div class="row ">
            <div class='col-sm-2 col-md-1 '>&nbsp;
              <label attr.aria-label="{{sku.skuType}}" [attr.for]="formName +'-serviceconfig' + i +'-'+ idx" [attr.for]="'rememberMe' + i "
                class="radio" (change)="radioselection(i,$event)"> 
                <input type="radio" id="rememberMe{{i}}" name='itemlist' [disabled]="disableRadio" [checked]="sku.selected">
                <i class="skin"></i>
                <div class="hide-element">{{sku.skuType}}</div>
              </label>
            </div>
            <div class='col-sm-10 col-md-5'>
              <h3 class="heading-bold" [innerHTML]="sku.skuType"> </h3>
              <div class="sku-text-sm" [innerHTML]="sku.moduleCount"></div>
            </div>
            <div class='col-sm-10 col-md-6 col-sm-offset-2' *ngIf = "this.totPricingObj.singleQuantityCheck > 1">
              <p class="last-text text-label">License price</p>
			  <span >
              <div  *ngFor="let iterateVolumeContent of sku.priceInfo.monthlyRecurringFee.price; let contentIndex = index">
                <div class="price-value" *ngIf="contentIndex === 0">
                  {{iterateVolumeContent.amount | currency:'USD':true:'1.2-3'}} user per month
                </div>
                <div class="price-value" *ngIf="sku?.priceInfo?.monthlyRecurringFee?.feeType === 'Tiered' && contentIndex > 0">
                  {{iterateVolumeContent.amount | currency:'USD':true:'1.2-3'}} more than {{iterateVolumeContent.minQty - 1}} users per month
                </div>
              </div>
			  </span>
            </div>
			<div class='col-sm-10 col-md-6 col-sm-offset-2' *ngIf = "this.totPricingObj.singleQuantityCheck == 1">
              <p class="last-text text-label">License price</p>
			  <span >
              <div  *ngFor="let iterateVolumeContent of sku.priceInfo.monthlyRecurringFee.price; let contentIndex = index">
                <div class="price-value" *ngIf="contentIndex === 0">
                  {{iterateVolumeContent.amount | currency:'USD':true:'1.2-3'}} per month
                </div>
                <div class="price-value" *ngIf="sku?.priceInfo?.monthlyRecurringFee?.feeType === 'Tiered' && contentIndex > 0">
                  {{iterateVolumeContent.amount | currency:'USD':true:'1.2-3'}} more than {{iterateVolumeContent.minQty - 1}}  per month
                </div>
              </div>
			  </span>
            </div>
			<!-- <div class='col-sm-10 col-md-6 col-sm-offset-2' *ngIf = "this.totPricingObj.singleQuantityCheck == 100000">
              <p class="last-text text-label">License price</p>
			  <span class="price-value" >Unlimited Users</span> 
            </div> -->
          </div>
        </div>
        <div class='col-md-5 col-sm-10 radio-margin'>
          <div class='row'>
            <div class='col-sm-12 col-md-6 separatorgrey'>
              <div class="price-detail" *ngIf='!!sku.priceInfo.totalOneTimeFee'>
                <p class="price-value">{{ sku.priceInfo.totalOneTimeFee && sku.priceInfo.totalOneTimeFee | currency:'USD':true:'1.2-3'}} </p>
                <p class="hide-md "> one-time charge </p>
              </div>

              <div class="price-detail" *ngIf='!sku.priceInfo.totalOneTimeFee'>
                <p class="price-value">{{ 0 | currency:'USD':true:'1.2-3'}} </p>
                <p class="hide-md"> one-time charge </p>
              </div>

            </div>
            <div class='col-sm-12 col-md-6 sku-per-month-fee'>
              <div class="price-detail">
                <p class="price-value" *ngIf='sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee && sku.priceInfo.monthlyRecurringFee.totalPrice != 0'>
                  {{sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee && sku.priceInfo.monthlyRecurringFee.totalPrice | currency:'USD':true:'1.2-3'}}
                </p>
                <p class="price-value" *ngIf='sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee && sku.priceInfo.monthlyRecurringFee.totalPrice === 0'>
                  {{sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee && sku.priceInfo.monthlyRecurringFee.totalPrice | currency:'USD':true:'1.2-3'}}
                </p>
                <p *ngIf = "this.totPricingObj.singleQuantityCheck > 1" class="hide-md last-text"> per month for {{this.tmpQty}} licenses</p>
				<p *ngIf = "this.totPricingObj.singleQuantityCheck == 1" class="hide-md last-text"> per month</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- hidden elements -->
      <div class="row" *ngIf="sku.selected">
        <div class='col-sm-10 col-md-5 pull-right radio-margin'>
          <div class="row">
            <div class="col-sm-12 col-md-6 " *ngIf='sku.priceInfo.oneTimeFee !== null'>
              <div *ngFor="let oneTimeFee of sku.priceInfo.oneTimeFee;">
                <div class='service-charge'>
                  <p class="small-left">{{oneTimeFee && oneTimeFee.feeType}} </p>
                  <div class="price-detail">
                    <p class="price-value">
                      <strong *ngIf='oneTimeFee && oneTimeFee.price[0].amount != 0'>{{oneTimeFee && oneTimeFee.price[0].amount | currency:'USD':true:'1.2-3'}}</strong>
                      <strong *ngIf='oneTimeFee && oneTimeFee.price[0].amount === 0'>{{oneTimeFee && oneTimeFee.price[0].amount | currency:'USD':true:'1.2-3'}}</strong>
                    </p>
                    <p> one-time charge</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='col-md-7 col-sm-12' *ngIf="sku.selected">
          <hr class="" />
          <div class="row">
            <div class='col-sm-10 col-md-10 skudesc bullet-list' [innerHTML]="sku.description"></div>
          </div>
        </div>

      </div>
    </div>

    <div class='singeline totalcontainer'>
      <div class='row'>
        <div class='col-md-7 col-sm-12'>
          <div class="col-sm-1 col-md-1">
          </div>
          <div class="col-sm-11 col-md-6">
            <h3 class="heading-bold">Total charges*</h3>
          </div>
          <div class="col-sm-11 col-md-5">
            <p> {{this.tmpQty}} <span [innerHTML]="(this.tmpQty > 1)? 'licenses':'license'"></span> &#64; {{this.totPricingObj.unitPrice
              | currency:'USD':true:'1.2-3'}}/<span *ngIf = "this.totPricingObj.singleQuantityCheck > 1">user</span> <span *ngIf = "this.totPricingObj.singleQuantityCheck == 1">month</span> </p>
          </div>
        </div>
        <div class='col-sm-10 col-md-5 radio-margin'>
          <div class='row'>
            <div class='col-md-6 col-sm-12 separatorwhite '>

              <div class="price-detail">
                <p class="price-value" *ngIf='totPricingObj && totPricingObj.oneTime != 0'>{{ totPricingObj && totPricingObj.oneTime | currency:'USD':true:'1.2-3'}} </p>
                <p class="price-value" *ngIf='totPricingObj && totPricingObj.oneTime === 0'>{{ totPricingObj && totPricingObj.oneTime | currency:'USD':true:'1.2-3'}} </p>
                <p>one-time charge </p>
              </div>

            </div>
            <div class='col-md-6 col-sm-12'>
              <div class="price-detail">
                <p class="price-value" *ngIf='totPricingObj && totPricingObj.perMonth != 0'>{{ totPricingObj && totPricingObj.perMonth | currency:'USD':true:'1.2-3'}} </p>
                <p class="price-value" *ngIf='totPricingObj && totPricingObj.perMonth === 0'>{{ totPricingObj && totPricingObj.perMonth | currency:'USD':true:'1.2-3'}} </p>
                <p>per month </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <small>* Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.</small>
    <hr class="cart-hr total-border" />
    <div class='text-right'>
      <button type="button" class="btn btn-success btn-cart pull-right addToCartE2ETest" [disabled]="!serviceconfigurationform.valid || priceErr"
        (click)='addToCart($event)' attr.aria-label="Add {{ productDetail.displayName }} to cart.">Add to cart</button>
      <a class="btn btn-link btn-cart" href="javascript:void(0)" (click)="gotoDetailPage(productDetail.id)">Cancel</a>
    </div>
    </form>
</div>
</main>